import { DatePipe } from '@angular/common';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDateFormats } from '@angular/material/core';

export const MY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

export class MyDateAdapter extends NativeDateAdapter {
  format(date: Date): string {
    return new DatePipe('en-US').transform(date, 'MMM dd yyyy');
  }
}

export const MY_DATE_FORMATS = {
  provide: MAT_DATE_FORMATS,
  useValue: MY_FORMATS,
};

export const MY_DATE_ADAPTER = {
  provide: DateAdapter,
  useClass: MyDateAdapter,
  deps: [MAT_DATE_FORMATS],
};
